import { useInstallmentPartner } from './use-installment-partner'

/**
 * Légende des deux modes de paiement portés par les cartes de vol.
 *
 * Aplats de couleur assumés (bleu Massilia / rose partenaire), demandés au
 * ticket. Deux points non négociables si on y touche :
 *
 * 1. La page résultats est sur `bg-blue-50`. Un bloc en `blue-50` s'y fond au
 *    point de disparaître — d'où le `-100` bordé de `-200`, pas plus clair.
 * 2. Les logos Oney (JPEG) et FLOA (PNG sans alpha) portent leur propre fond
 *    blanc : sur un aplat teinté ils dessineraient un rectangle. La pastille
 *    blanche est là pour ça, et elle est mise des deux côtés pour que les deux
 *    logos reposent sur le même socle.
 *
 * Le texte se teinte depuis la couleur du bloc, jamais en gris : du gris sur un
 * aplat coloré se lit comme une erreur de rendu.
 */
export function PaymentInfoBanner() {
  const partner = useInstallmentPartner()

  return (
    <div className="mb-4 grid gap-3 md:grid-cols-2">
      <div className="rounded-lg border border-blue-200 bg-blue-100 p-4 shadow-sm">
        <div className="mb-2 flex items-center gap-2.5">
          <span className="flex shrink-0 items-center rounded bg-white px-1.5 py-1">
            <img alt="Massilia Voyages" className="h-5 w-auto" src="/logos/massilia-logo.png" />
          </span>
          <span className="text-sm font-semibold text-blue-950">
            Paiement en plusieurs fois Massilia Voyages
          </span>
        </div>
        <p className="text-sm leading-relaxed text-blue-950/80">
          Versez un acompte à la réservation, puis payez en plusieurs fois{' '}
          <span className="font-semibold text-green-800">sans frais</span>, tous les mois
          jusqu&apos;au départ.
        </p>
      </div>

      <div className="rounded-lg border border-pink-200 bg-pink-100 p-4 shadow-sm">
        <div className="mb-2 flex items-center gap-2.5">
          <span className="flex shrink-0 items-center rounded bg-white px-1.5 py-1">
            <img alt={partner.name} className="h-5 w-auto" src={partner.logoSrc} />
          </span>
          <span className="text-sm font-semibold text-pink-950">
            Paiement en plusieurs fois {partner.name}
          </span>
        </div>
        <p className="text-sm leading-relaxed text-pink-950/80">
          Payez en 1 fois, ou en plusieurs fois avec frais via notre partenaire{' '}
          <span className="font-semibold text-pink-950">{partner.name}</span>.
        </p>
      </div>
    </div>
  )
}
